import React from 'react';
import Modal from 'react-modal';
import { Box, Typography } from '@mui/material';

const leftBoxSx = { width: '40%', textAlign: 'left' };
const rightBoxSx = { width: '60%', textAlign: 'left', wordBreak: 'break-word', overflowWrap: 'break-word' };

const ClirRiskResultsModal = ({ open, onClose, row }) => {
  if (!row) return null;

  const renderToolExceptions = (arr) => {
    if (!Array.isArray(arr) || arr.length === 0) {
      return (
        <Box sx={rightBoxSx}>
          <Typography variant="body1">N/A</Typography>
        </Box>
      );
    }
    return (
      <Box sx={rightBoxSx}>
        {arr.map((item, idx) => (
          <React.Fragment key={idx}>
            {item.rule && <Typography>{item.rule}</Typography>}
            {item.result && <Typography>{item.result}</Typography>}
            {item.applied && <Typography>{item.applied}</Typography>}
          </React.Fragment>
        ))}
      </Box>
    );
  };

  const renderCalculationErrors = (arr) => {
    if (!Array.isArray(arr) || arr.length === 0) {
      return (
        <Box sx={rightBoxSx}>
          <Typography variant="body1">N/A</Typography>
        </Box>
      );
    }
    return (
      <Box sx={rightBoxSx}>
        {arr.map((item, idx) => (
          <Typography key={idx}>{item}</Typography>
        ))}
      </Box>
    );
  };

  return (
    <Modal
      className="modal"
      overlayClassName="modalOverlay"
      aria-modal="true"
      contentLabel="CLIR Risk Score Tool Results"
      shouldCloseOnOverlayClick={true}
      isOpen={open}
      onRequestClose={onClose}
    >
      <div className="modalHeader">CLIR Risk Score Tool Results</div>
      <div className="modalContent">
        <div className="modalSection">
          <div className="sectionHeading center">
            <Typography variant="body1" gutterBottom>{row.toolName || 'Results'}</Typography>
          </div>
          <Box sx={{ mt: 4, pl: 4, pr: 4 }}>
            <Box display="flex" flexDirection="row" mb={1}>
              <Box sx={leftBoxSx}>
                <Typography>Score:</Typography>
              </Box>
              <Box sx={rightBoxSx}>
                <Typography>
                  {row.score !== null && row.score !== undefined ? Number(row.score).toFixed(2) : 'N/A'}
                </Typography>
              </Box>
            </Box>
            <Box display="flex" flexDirection="row" mb={1}>
              <Box sx={leftBoxSx}>
                <Typography>Case Count:</Typography>
              </Box>
              <Box sx={rightBoxSx}>
                <Typography>
                  {row.caseCount !== null && row.caseCount !== undefined ? row.caseCount : 'N/A'}
                </Typography>
              </Box>
            </Box>
            <Box display="flex" flexDirection="row" mb={1}>
              <Box sx={leftBoxSx}>
                <Typography>Guideline:</Typography>
              </Box>
              <Box sx={rightBoxSx}>
                <Typography>
                  {row.guideLine || 'N/A'}
                </Typography>
              </Box>
            </Box>
            <Box display="flex" flexDirection="row" mb={1}>
              <Box sx={leftBoxSx}>
                <Typography>Percentile:</Typography>
              </Box>
              <Box sx={rightBoxSx}>
                <Typography>
                  {row.percentile !== null && row.percentile !== undefined ? (row.percentile * 100).toFixed(1) + '%' : 'N/A'}
                </Typography>
              </Box>
            </Box>
            <Box display="flex" flexDirection="row" mb={1}>
              <Box sx={leftBoxSx}>
                <Typography>Is Informative:</Typography>
              </Box>
              <Box sx={rightBoxSx}>
                <Typography>
                  {row.isInformative !== null && row.isInformative !== undefined ? String(row.isInformative) : 'N/A'}
                </Typography>
              </Box>
            </Box>
            <Box display="flex" flexDirection="row" alignItems="flex-start" mb={1}>
              <Box sx={leftBoxSx}>
                <Typography>Tool Exceptions:</Typography>
              </Box>
              {renderToolExceptions(row.toolExceptions)}
            </Box>
            <Box display="flex" flexDirection="row" alignItems="flex-start" mb={1}>
              <Box sx={leftBoxSx}>
                <Typography>Calculation Errors:</Typography>
              </Box>
              {renderCalculationErrors(row.calculationErrors)}
            </Box>
          </Box>
        </div>
      </div>
      <div className="modalButtons">
        <button
          onClick={onClose}
          className="modalButton"
          variant="contained"
          aria-label="close CLIR Risk Score Results modal"
        >
          Close
        </button>
      </div>
    </Modal>
  );
};

export default ClirRiskResultsModal;